import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "src/services/commonLanguageHeader";
import { ServicesUrlEndpoints } from "src/services/servicesEndpointConstant";

export type ModelPropertySortDirection = "ASC" | "DESC";

export interface NamedReference {
  id?: string | number;
  name?: string;
  code?: string;
  propertyNameComm?: string;
  propertyNameInternal?: string;
  description?: string;
  make?: NamedReference | null;
}

export interface ModelPropertyListParams {
  page?: number;
  size?: number;
  sort?: ModelPropertySortDirection;
  sortBy?: string;
}

export interface ModelPropertyRecord {
  id: string | number;
  make?: NamedReference | null;
  model?: NamedReference | null;
  property?: NamedReference | null;
  active?: boolean | number | string;
  [key: string]: unknown;
}

export interface ModelPropertyPayload {
  makeId: string | number;
  modelId: string | number;
  propertyId: string | number;
  active: boolean;
}

export interface ModelPropertyPaginatedResponse {
  modelProperties?: ModelPropertyRecord[];
  data?: ModelPropertyRecord[];
  items?: ModelPropertyRecord[];
  content?: ModelPropertyRecord[];
  totalItems?: number;
  totalElements?: number;
  total?: number;
}

export interface LookupResponse {
  response?: NamedReference[];
  data?: NamedReference[];
  items?: NamedReference[];
}

const replaceId = (url: string, id: string | number) =>
  url.replace("{id}", String(id));

export const getModelPropertiesList = (
  params: ModelPropertyListParams = {},
  language?: string,
) =>
  ApiService.get<{ response: ModelPropertyPaginatedResponse }>(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.ADD_MODEL_PROPERTIES.LISTING,
    {
      params,
      ...getLanguageHeaders(language),
    },
  );

export const createModelProperty = (
  payload: ModelPropertyPayload,
  language?: string,
) =>
  ApiService.post(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.ADD_MODEL_PROPERTIES.ADD,
    payload,
    {
      ...getLanguageHeaders(language),
      skipErrorNotification: true,
    },
  );

export const updateModelProperty = (
  id: string | number,
  payload: Partial<ModelPropertyPayload>,
  language?: string,
) =>
  ApiService.patch(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.ADD_MODEL_PROPERTIES.UPDATE, id),
    payload,
    {
      ...getLanguageHeaders(language),
      skipErrorNotification: true,
    },
  );

export const deleteModelProperty = (id: string | number, language?: string) =>
  ApiService.delete(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.ADD_MODEL_PROPERTIES.DELETE, id),
    getLanguageHeaders(language),
  );

export const getUnitModelsByMake = (makeId: string | number, language?: string) =>
  ApiService.get<LookupResponse>(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.LOOKUP.UNIT_MODELS_BY_MAKE, makeId),
    getLanguageHeaders(language),
  );

export const getPropertiesByMake = (makeId: string | number, language?: string) =>
  ApiService.get<LookupResponse>(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.LOOKUP.PROPERTIES_BY_MAKE, makeId),
    getLanguageHeaders(language),
  );
